/**
 * Created by jonas on 2022-06-15.
 */
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {BS2} from "../../../BS2";
import {BS2Symbol} from "../../../reels/BS2Symbol";
import {BS2Statics} from "../../../config/BS2Statics";
import {ScatterSymbol} from "../../../reels/ScatterSymbol";
import {GSAPUtils} from "../../../utils/GSAPUtils";
import {StateMatrixCoordinate} from "../../../utils/StateMatrix";
import {PopAndMoveData, replaceWithNewSymbolDataType, SpinMode} from "../../../server/BS2Data";
import {SimpleReelModelSymbolData} from "../../../../core/reel/simplereel/SimpleReelModel";
import {BS2GameMode} from "../../../server/BS2GameMode";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class CollectScattersPresentationAvalanche implements SimplePresentation {
    name: string = "CollectScattersPresentationAvalanche";
    private allSSymbolPositions: StateMatrixCoordinate[];

    constructor() {
    }

    public static getSqueezeAnimation(scatterPos: StateMatrixCoordinate): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const ease: string = "slow(0.5, 0.7, false)";
        const data: PopAndMoveData = CollectScattersPresentationAvalanche.popScatterAndMove(scatterPos, ease);
        const scatterSymbol: ScatterSymbol = <ScatterSymbol>data.symbolData.positionable;
        const scatterSymbolSqueezeAnim: gsap.core.Timeline = scatterSymbol.getSqueezeAnimation().pause();
        BS2.reelView.addSqueezedScatter(scatterSymbol);

        tl.add(scatterSymbolSqueezeAnim.play());
        tl.addLabel("startAddTextToProgressionBar", "<0.1")
        tl.add(() => BS2.reelView.collectBar.addScatterToBar(), "<0.9");
        tl.add(() => {
            if (!(BS2.model.data.mode === BS2GameMode.FREESPIN_SUPER || BS2.model.data.mode === BS2GameMode.AVALANCHE_FREESPIN_SUPER) && scatterSymbol.symbolPosition) {
                this.checkForTimeScale() ? BS2.reelView.addTextToProgressionBar.moveToProgressionBar(scatterSymbol.symbolPosition.reelID, scatterSymbol.symbolPosition.position, "S", (scatterSymbolSqueezeAnim.totalDuration() - 0.6)).timeScale(1.3)
                    : BS2.reelView.addTextToProgressionBar.moveToProgressionBar(scatterSymbol.symbolPosition.reelID, scatterSymbol.symbolPosition.position, "S", (scatterSymbolSqueezeAnim.totalDuration() - 0.6));
            }
        }, "startAddTextToProgressionBar")
        tl.add(data.moveAnimation, 0);
        return tl;
    }

    public static checkForTimeScale():boolean{
        const splitData=JSON.parse(JSON.stringify(BS2.model.data.splitDirections));
        if(BS2.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            if (BS2.model.winData.lines.length > 0) {
                return false;
            }
            if (BS2.model.data.upgradeLevel) {
                return false;
            }
            for (let i = 0; i < splitData.length; i++) {
                for (let j = 0; j < splitData[i].length; j++) {
                    if (splitData[i][j] !== -1) {
                        return false;
                    }
                }
            }
        }
        return true;

    }

    public static popScatterAndMove(scatterPos: StateMatrixCoordinate, ease: string): PopAndMoveData {
        if (BS2.reelView.reels[scatterPos.column].model.symbols[0].name != BS2.model.data.reels[scatterPos.column][0]) {
            const replaceData: replaceWithNewSymbolDataType = BS2.reelView.reels[scatterPos.column].model.replaceWithNewSymbol(0, BS2.model.data.reels[scatterPos.column][0]);  //replace the symbol to be revealed to match current data.
        }
        const allSymbolsAboveScatter: SimpleReelModelSymbolData[] = BS2.reelView.reels[scatterPos.column].model.symbols.splice(0, scatterPos.row + 2); //the +2 is the number of padding symbols and to include S
        const scatterSymbolData: SimpleReelModelSymbolData = allSymbolsAboveScatter.pop()!; //grab the scatter

        BS2.reelView.reels[scatterPos.column].model.symbols.unshift(...allSymbolsAboveScatter); //Put the symbols back in reel.

        const duration: number = 0.5;
        const moveTl: gsap.core.Timeline = gsap.timeline();
        for (let moveSymbol of allSymbolsAboveScatter) {
            moveSymbol.reelPosition += 1;
            const symbol: BS2Symbol = <BS2Symbol>moveSymbol.positionable;
            symbol.symbolPosition = {
                reelID: moveSymbol.reelId,
                position: moveSymbol.reelPosition
            }
            moveTl.add(gsap.to(symbol, {
                duration: duration,
                y: symbol.position.y + BS2Statics.STEP_HEIGHT,
                ease: ease
            }), "<");
        }

        BS2.reelView.reels[scatterPos.column].model.unshiftRandomSymbol(); //Unshift a new random symbol, because we are removing the scatter. (Keeps reel length intact)


        return {
            symbolData: scatterSymbolData,
            moveAnimation: moveTl
        }

    }

    shouldRun(): boolean {
        if (BS2.model.currentSpinMode() === SpinMode.SPIN || BS2.model.isSuperFreespin()) {
            return false;
        }
        this.allSSymbolPositions = BS2.model.visibleReelMatrix.getAllCoordinatesForValue(BS2Statics.SYMBOLS.S);
        return this.allSSymbolPositions.length > 0;
    }

    start(controller: SimplePresentationRunnerController): void {

        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                controller.finish();
            }
        });
        tl.add(() => controller.setSkipCallback());

        const squeezeAnimations = [];

        for (let pos of this.allSSymbolPositions) {
            const squeezeTl: gsap.core.Timeline = gsap.timeline();
            squeezeTl.add(CollectScattersPresentationAvalanche.getSqueezeAnimation(pos));
            squeezeAnimations.push(squeezeTl);
        }

        tl.add(GSAPUtils.createTimelineFromArray(squeezeAnimations, "<0.1"));
        tl.to(this, {duration: 0.01});

    }

}